import classNames from 'classnames';
import React from 'react';
import './selectOutlet.style.scss';
interface ISelectOutletProps extends React.HTMLProps<HTMLSelectElement> {
  label: string;
  required?: boolean;
  errors?: string;
  name: string;
  touched?: boolean;
  options: Array<IOption>;
  isGreen?: boolean;
  hasEmptyData?: boolean;
  height?: string;
}

const SelectOutlet = ({
  label,
  required = false,
  errors,
  touched,
  name,
  disabled,
  options,
  isGreen,
  hasEmptyData,
  height,
  ...props
}: ISelectOutletProps) => {
  return (
    <div
      className={classNames(
        isGreen ? 'floating-label-select-isGreen' : 'floating-label-select',
      )}
    >
      <select
        id={name}
        name={name}
        data-value={props.value}
        {...props}
        disabled={disabled}
        value={props.value}
        className={
          (touched && errors ? 'invalid ' : '') +
          (touched && !errors ? 'valid' : '') +
          (height && '!' + height)
        }
      >
        {hasEmptyData && <option></option>}
        {React.Children.toArray(
          options?.map((item, index) => (
            <>
              <option key={index} value={item.value}>
                {item.label}
              </option>
            </>
          )),
        )}
      </select>
      <label
        htmlFor={name}
        className={classNames({
          'select-label-invalid ': touched && errors,
          'select-label-valid': touched && !errors,
        })}
      >
        {label} {required && <span className="color-red-3">*</span>}
      </label>
      {touched && errors && (
        <>
          <div className="pt-1">
            <small>
              <i className="icon-warning"></i> {errors}
            </small>
          </div>
        </>
      )}
    </div>
  );
};

export default SelectOutlet;
SelectOutlet.defaultProps = {
  hasEmptyData: true,
};
